<template lang="pug">
.wt-entity-avatar
  figure.image(:class="!mapMarker && sizeClass")
    img(
      :class="imgClass"
      :style="imgStyle"
      :src="avatar"
      alt="avatar"
      @error="avatarOnError"
    )
</template>

<script>
export default {
  name: "WtEntityAvatar",

  props: {
    image: {
      type: String,
      default: null
    },

    sizeClass: {
      type: String,
      default: "is-96x96"
    },

    mapMarker: {
      type: Boolean,
      default: false
    },

    index: {
      type: Number,
      default: null
    },

    isRounded: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      avatarPlaceholder:
        "https://walkertracker.s3.amazonaws.com/avatars/anonymous.png",
      colors: this._app_chart_colors_multiple
    };
  },

  computed: {
    avatar() {
      return this.image || this.avatarPlaceholder;
    },

    imgClass() {
      let imgClass = "";

      if (this.mapMarker) {
        return "marker is-rounded";
      }

      if (this.isRounded) {
        imgClass += " is-rounded ";
      }

      return imgClass;
    },

    colorCycle() {
      const colorKeys = Object.keys(this.colors);
      const color = colorKeys[this.index % colorKeys.length];
      return this.colors[color];
    },

    imgStyle() {
      let imgStyle = {};

      if (this.mapMarker) {
        // note, wt-styles.sass for the rest of .marker
        imgStyle = {
          ...imgStyle,
          border: `2px solid ${this.colorCycle}`
        };
      }
      if (!this.isRounded && !this.mapMarker) {
        imgStyle = { ...imgStyle, borderRadius: "6px" }; // $radius-large
      }

      return imgStyle;
    }
  },

  methods: {
    avatarOnError(event) {
      event.target.onerror = null;
      event.target.src = this.avatarPlaceholder;
    }
  }
};
</script>

<style scoped lang="sass"></style>
